import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-14 h-8 rounded-full border border-border transition-colors duration-300 overflow-hidden ${isDark ? 'bg-slate-800' : 'bg-amber-100'}`}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Knob — icon lives inside so it renders on top of the track */}
      <div
        className={`absolute top-1 w-6 h-6 rounded-full shadow-md transition-transform duration-300 flex items-center justify-center z-10
          ${isDark ? 'bg-slate-700 translate-x-7' : 'bg-white translate-x-1'}`}
      >
        <span className="text-sm leading-none select-none">
          {isDark ? '🌙' : '☀️'}
        </span>
      </div>
    </button>
  );
};

export default ThemeToggle;
